import React from 'react';
import { X, FileText, FileImage, FileSpreadsheet, Clock } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { iProcess } from '../../../../components/type';

//inyerface

import { iMap } from '../../../../components/type';

interface SelectedItemsDisplayProps {
    selectedFile: File | null;
    selectedMaps: iMap[];
    swimlanes: any[]; // tu peux typer si besoin
    onRemoveFile: () => void;
    onRemoveMap: (mapId: string) => void;
    className?: string;
}

const SelectedItemsDisplay: React.FC<SelectedItemsDisplayProps> = ({
    selectedFile,
    selectedMaps,
    swimlanes,
    onRemoveFile,
    onRemoveMap,
    className = ''
}) => {
    const { t } = useTranslation();

    const getFileIcon = (file: File) => {
        const type = file.type.toLowerCase();
        if (type.includes('image')) return <FileImage size={16} className="text-green-600" />;
        if (type.includes('spreadsheet') || type.includes('csv')) return <FileSpreadsheet size={16} className="text-blue-600" />;
        return <FileText size={16} className="text-gray-600" />;
    };

    const formatFileSize = (bytes: number) => {
        if (bytes === 0) return '0 Bytes';
        const k = 1024;
        const sizes = ['Bytes', 'KB', 'MB', 'GB'];
        const i = Math.floor(Math.log(bytes) / Math.log(k));
        return parseFloat((bytes / Math.pow(k, i)).toFixed(1)) + ' ' + sizes[i];
    };

    if (!selectedFile && selectedMaps.length === 0) {
        return null;
    }

    return (
        <div className={`bg-gray-50 border border-gray-200 rounded-xl p-4 space-y-3 ${className}`}>
            <div className="flex items-center gap-2 text-sm font-medium text-gray-700">
                <Clock size={16} className="text-blue-500" />
                {t('features.swimlane.selectedForAnalysis')}
            </div>

            <div className="space-y-2">
                {/* Selected File */}
                {selectedFile && (
                    <div className="group bg-white border border-gray-200 rounded-lg p-3 hover:border-gray-300 transition-all duration-200 hover:shadow-sm">
                        <div className="flex items-center justify-between">
                            <div className="flex items-center gap-3 flex-1 min-w-0">
                                <div className="flex-shrink-0">{getFileIcon(selectedFile)}</div>
                                <div className="flex-1 min-w-0">
                                    <p className="text-sm font-medium text-gray-900 truncate">
                                        {selectedFile.name}
                                    </p>
                                    <p className="text-xs text-gray-500">
                                        {formatFileSize(selectedFile.size)} • {t('features.swimlane.uploadedFile')}
                                    </p>
                                </div>
                            </div>
                            <button onClick={onRemoveFile} title={t('words.remove')}>
                                <X size={14} />
                            </button>
                        </div>
                    </div>
                )}

                {/* Selected Maps */}
                {selectedMaps.map((map) => (
                    <div
                        key={map._id}
                        className="group bg-white text-black border border-gray-200 rounded-lg p-3 hover:border-gray-300 transition-all duration-200 hover:shadow-sm"
                    >
                        <div className="flex items-center justify-between">
                            <div className="flex items-center gap-3 flex-1 min-w-0">
                                <div className="flex-shrink-0">
                                    <i className="fa-solid fa-diagram-project text-purple-600"></i>
                                </div>
                                <div className="flex-1 min-w-0">
                                    <p className="text-sm font-medium text-gray-900 truncate">
                                        {map.name}
                                    </p>
                                    <p className="text-xs text-gray-500 truncate">
                                        {map.process?.title}
                                    </p>
                                </div>
                            </div>
                            <button onClick={() => onRemoveMap(map._id)} title={t('words.remove')}>
                                <X className="text-red" size={14} />
                            </button>
                        </div>
                    </div>
                ))}
            </div>

            <div className="pt-2 border-t border-gray-200">
                <p className="text-xs text-gray-500 text-center">
                    {selectedFile && selectedMaps.length > 0
                        ? `1 ${t('words.file')} • ${selectedMaps.length} ${selectedMaps.length > 1 ? t('words.maps') : t('words.map')}`
                        : selectedFile
                            ? `1 ${t('words.file')}`
                            : `${selectedMaps.length} ${selectedMaps.length > 1 ? t('words.maps') : t('words.map')}`
                    }
                </p>
            </div>
        </div>
    );
};

export default SelectedItemsDisplay;
